module.exports = __webpack_public_path__ + "img/product-promote.3ba23ab1.jpg";